"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

function CrudDetail(props) {
  var data = props.data,
      ViewUI = props.ViewUI,
      FormUI = props.FormUI,
      promise = props.promise,
      _Form = props.Form,
      Toggle = props.Toggle;

  var _react_1$useState = react_1.useState(data),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var handleUpdate = function handleUpdate(d) {
    setState(d);
  };

  return react_1.default.createElement(Toggle, {
    View: function View(props) {
      return react_1.default.createElement(ViewUI, Object.assign({
        data: state
      }, props));
    },
    Form: function Form(props) {
      return react_1.default.createElement(_Form, Object.assign({
        UI: FormUI,
        data: Object.assign({}, state),
        promise: promise,
        onUpdate: handleUpdate
      }, props));
    }
  });
}

exports.default = CrudDetail;